module.exports = __webpack_public_path__ + "img/inviting-patients-icon.21cc6dc1.svg";